"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const BlockEmbed = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("rect", { width: 24, height: 18, y: 3, fill: "#1099FC", className: styles.accentColor, rx: 2 }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "m10 16.309 2.71-8.976 1.214.358-2.71 8.976zM8.447 14.99 5.333 11.7l3.114-3.298.886.944L7.107 11.7l2.226 2.347zm7.107 0-.887-.944 2.226-2.347-2.226-2.354.886-.944 3.114 3.298z"
      }
    )
  );
};
export default BlockEmbed;
